var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5207\u7247") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u4E00\\u952E\\u751F\\u6210\\u79FB\\u52A8\\u7AEF",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6211\\u7684",
    transform: "translate(-28.000000, -124.000000)",
    fill: "#2C2C2C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u751F\\u6210\\u8BB0\\u5F55\\u5907\\u4EFD-3",
    transform: "translate(28.000000, 124.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "xiazai-26",
    transform: "translate(3.200000, 2.200000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.308,13.286 L0,13.286 L0,14.6 L13.308,14.6 L13.308,13.286 Z M7.384,8.8817842e-16 L6.07,8.8817842e-16 L6.0705412,9.29949533 L2.292,5.521 L1.363,6.449 L6.735,11.821 L12.107,6.45 L11.178,5.521 L7.38409253,9.31793623 L7.384,8.8817842e-16 Z",
    id: "\\u5F62\\u72B6"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.d664c379f613b7b5a9aa8a7077e94723.svg";
export { ForwardRef as ReactComponent };